import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";

const VerticalAlignTop = (props: any) => {
  return <VerticalAlignTopIcon {...props} />;
};

export default VerticalAlignTop;
